import * as React from "react";
import GalleryService from "../../services/gallery";
import { DANH_MUC } from "../../const/danh-muc";
import ContentComponent from "../share/ContentComponent";
import SpinnersImageText from "../share/Spinners/SpinnersImageText";
import Modal from "../share/Modal";
// import ReactYoutube from "react-youtube";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    // marginRight: '-50%',
    transform: "translate(-50%, -50%)",
    // width: '590px',
    background: "none",
    padding: 0,
    border: "none",
    "border-radius": "0px",
  },
  overlay: {
    zIndex: 99,
    backgroundColor: "rgba(2, 2, 2, 0.38)",
  },
};
export default class ThuVienVideo extends React.Component<any, any> {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      danhMucActive: DANH_MUC.VIDEO_HĐVH,
      danhSachGalleryVideo: [],
    };
  }

  componentDidMount() {
    this.getData(DANH_MUC.VIDEO_HĐVH);
  }

  getData(danhMuc) {
    this.setState({
      loading: true,
    });
    GalleryService.getList(danhMuc, "v", 1, 3).then((value) => {
        this.setState({
          loading: false,
          danhSachGalleryVideo: value.galleries,
          danhMucActive: danhMuc,
        });
    });
  }

  onTab(id) {
    if (id == "videohoatdongvuihoc") {
      this.getData(DANH_MUC.VIDEO_HĐVH);
    }
    if (id == "videosukien") {
      this.getData(DANH_MUC.VIDEO_SU_KIEN);
    }
    if (id == "videothamquan") {
      this.getData(DANH_MUC.VIDEO_THAM_QUAN);
    }
  }
  openModal(id) {
    this.setState({
      id: id,
      openModal: true,
    });
  }
  closeModal() {
    this.setState({
      openModal: false,
    });
  }
  modal() {
    const videoSrc = `https://www.youtube.com/embed/${this.state.id}`;
    return (
      <Modal
        isOpen={this.state.openModal}
        className="modal-video-yb"
        onRequestClose={() => this.closeModal()}
        contentLabel="Minimal Modal Example"
        style={customStyles}
        aria={{
          labelledby: "modalTitle",
        }}
      >
        {/* <ReactYoutube
          videoId={this.state.id}
          opts={{
            width: "100%",
          }}
        /> */}
         <span>
          <iframe allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" title="" width="100%" height="360" src={videoSrc} id="widget2" data-gtm-yt-inspected-9="true"></iframe>
        </span>
      </Modal>
    );
  }

  buildContent() {
    if (this.state.loading) {
      return <div></div>;
    }
    if (this.state.danhSachGalleryVideo.length == 0) {
      return <div style={{padding:'1rem'}}>No data</div>;
    }
    if (this.state.danhSachGalleryVideo.length > 0) {
      return this.state.danhSachGalleryVideo.map((video) => {
        var id;
        if (video.data.id.indexOf("&") == -1) {
          id = video.data.id;
        } else {
          id = video.data.id.substring(0, video.data.id.indexOf("&"));
        }
        return (
          <div
            className="col-md-4"
            style={{ paddingLeft: "5px", paddingRight: "5px" }}
            onClick={() => this.openModal(id)}
            key={id}
          >
            <div
              className="div-video-yb"
              style={{ backgroundImage: "url(" + video.hinh_dai_dien + ")" }}
            >
              <div className="btn-play-yb">
                <div className="icon-play" />
              </div>
            </div>
            <div
              className="title-video text-center trimtext  back-yellow"
              style={{ color: "rgb(46, 49, 145)" }}
            >
              <b>{video.tieu_de}</b>
            </div>
          </div>
        );
      });
    }
  }
  loading() {
    if (this.state.loading) {
      return <SpinnersImageText type={"placeholde"} loading={true} />;
    }
  }

  render() {
    return (
      <React.Fragment>
        {this.modal()}
        <ContentComponent content={this.props.content} />
        <div className="block back-gray">
          <div className="container">
            <div className="row" style={{ margin: "0px" }}>
              <div className="col-sm-12 text-left ">
                <b
                  style={{
                    borderLeft: "5px solid #ff0000",
                    padding: "0 10px",
                  }}
                >
                  PLAYLISTS
                </b>
              </div>
            </div>
            <div className="row" style={{ margin: 0 }}>
              <div className="col-sm-12 pl-0 pr-0 pt-3">
                {/* tab */}
                <ul className="nav nav-tabs">
                  <li className="nav-item">
                    <a
                      data-target="#videohoatdongvuihoc"
                      data-toggle="tab"
                      className="nav-link active show"
                      onClick={() => this.onTab("videohoatdongvuihoc")}
                    >
                      LEARNING ACTIVITIES
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      data-target="#videosukien"
                      data-toggle="tab"
                      className="nav-link"
                      onClick={() => this.onTab("videosukien")}
                    >
                      EVENTS
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      data-target="#videothamquan"
                      data-toggle="tab"
                      className="nav-link "
                      onClick={() => this.onTab("videothamquan")}
                    >
                      SCHOOL TRIPS
                    </a>
                  </li>
                </ul>
                {/* Nội dung */}
                <div className="tab-content ">
                  <div
                    className="tab-pane container active show"
                    id="videohoatdongvuihoc"
                  >
                    {this.loading()}
                    <div className="row">
                      {this.buildContent()}
                      <div className="col-12 text-right">
                      <a href={ "/video-list?album=" + this.state.danhMucActive} className="text-red text-bold">
                          {" "}
                          <i
                            className="fa fa-plus-square fa-1 text-red"
                            aria-hidden="true"
                          />{" "}
                          See all{" "}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
